// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styles } from "@bg/App/Widgets/CheckoutStepper/CheckoutStepper";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.stepsWrapperStyles = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        overflow: hidden;
    `,
};

styles.stepStyles = {
    css: css`
        @media (min-width: 481px) {
            padding-left: 5px;
            margin-bottom: 8px;

            &:first-child {
                padding-left: 0;
            }

            &:last-child {
                > button:after {
                    content: none;
                }
            }

            button:after {
                width: calc(calc(100% - 120px) / 3);
            }

            &:nth-child(1) {
                button:after {
                    left: 55px;
                }
            }
            &:nth-child(2) {
                button:after {
                    left: calc(calc(100% + 80px) / 3);
                }
            }
            &:nth-child(3) {
                button:after {
                    left: calc(calc(100% / 3) * 2);
                }
            }

            &.stps3 {
                button:after {
                    width: calc(calc(100% - 105px) / 2);
                }
                &:nth-child(2) {
                    button:after {
                        left: calc(calc(100% + 44px) / 2);
                    }
                }
            }

            &.stps2 {
                button:after {
                    width: calc(100% - 80px);
                }
            }

            &.disabled {
            }

            &.active,
            &.completed {
            }
        }
    `,
};

styles.stepClickableStyles = {
    css: css`
        @media (min-width: 481px) {
            display: flex;
            align-items: center;
            flex-direction: column;
            z-index: 1;
            cursor: initial !important;

            .icon-check {
                display: none;
            }

            &:after {
                content: "";
                border-top: 2px solid ${getColor("common.ui3")};
                position: absolute;
                top: 15px;
                right: 0;
                left: auto;
                z-index: 1;
            }

            &.active {
                .step-number,
                .step-text * {
                    color: ${getColor("text.main")};
                    border-color: ${getColor("text.main")};
                    cursor: pointer;
                }
            }

            &.completed {
                .step-number {
                    background-color: ${getColor("text.main")};
                    border-color: ${getColor("text.main")};
                    color: ${getColor("common.white")};
                    cursor: pointer;
                }

                .step-text * {
                    color: ${getColor("text.main")};
                    cursor: pointer;
                }

                &:after {
                    border-color: ${getColor("text.main")};
                }
            }

            &.disabled {
                .step-number {
                    cursor: not-allowed;
                    background-color: ${getColor("common.ui3")};
                    border-color: ${getColor("common.ui3")};
                    color: ${getColor("text.main")};

                    .number {
                        opacity: 0.4;
                    }
                }

                .step-text * {
                    cursor: not-allowed;
                    color: ${getColor("common.ui3")};
                }
            }

            ${({ asLink }: any) =>
                asLink &&
                css`
                    padding-left: 0 !important;
                    padding-right: 5px !important;
                `}
        }
    `,
};

styles.stepNumberStyles = {
    css: css`
        color: ${getColor("text.main")};
        width: 32px;
        height: 32px;
        min-width: 32px;
        min-height: 32px;
        background-color: ${getColor("common.white")};
        border: 2px solid ${getColor("text.main")};
        text-align: center;
        font-size: 15px;
        line-height: 20px;
        font-weight: 500;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 8px;
        border-radius: 50%;
        z-index: 2;
    `,
};

styles.stepTextStyles = {
    size: 14,
    lineHeight: "20px",
    color: "text.main",
    css: css`
        font-weight: 500;
        letter-spacing: 1px;
    `,
};
